import mitt, { Emitter } from 'mitt'

type Events = {
  deviceUpgrade: any; // 设备升级
  deviceLogUploadProgress: any // 设备日志上传
  flightTaskWs: any // 机场任务消息
  droneControlWs: any // 飞行指令信息
  droneControlMqttInfo: any // drc 链路通知
  flightAreasDroneLocationWs: any
  flightAreasSyncProgressWs: any
  flightAreasUpdateWs: any
  /** 右侧媒体列表刷新后，同步刷新左侧「非航线任务」按日期分组 */
  refreshNoTaskMediaDates: void
  /** 媒体库整页刷新：左侧分类树/任务列表（完成后会再发 refreshMediaTable） */
  refreshMediaPage: void
  /** 右侧图片列表刷新（分组树更新后触发） */
  refreshMediaTable: void
};

const emitter: Emitter<Events> = mitt<Events>()

export default emitter
